import axios from 'axios';

import { AxiosCache, AxiosCacheRequestConfig } from '../libs/AxiosCache';

export interface StudentType {
  userId: string
  courseId: string
  profile: {
    id: string
    emailAddress: string
    photoUrl: string
    name: {
      givenName: string
      familyName: string
      fullName: string
    }
  }
}

class Student implements StudentType {
  userId: string
  courseId: string
  profile: {
    id: string
    emailAddress: string
    photoUrl: string
    name: {
      givenName: string
      familyName: string
      fullName: string
    }
  }

  constructor(student: StudentType) {
    this.userId = student.userId;
    this.courseId = student.courseId;
    this.profile = student.profile;
  }

  static async findOne(query?: {courseId: string, userId: string}, config?: AxiosCacheRequestConfig): Promise<Student | null> {
    const { data } = await axios.get('/classroom/courses/student', AxiosCache.getConfig({
      ...config, params: query
    }));
    return data ? new Student(data) : null;
  }

  static async find(query?: {courseId: string}, config?: AxiosCacheRequestConfig): Promise<Student[]> {
    const { data = [] } = await axios.get('/classroom/courses/students/list', AxiosCache.getConfig({
      ...config, params: query
    }));
    return (data as StudentType[]).map(a => new Student(a));
  }
}

export default Student;
